module.exports = __webpack_public_path__ + "bt.svg?c2576eefb228a6390479600b4e0af3ee";